import pressImageFeatured from "../assets/press/press-2.svg";
import expoImage from "../assets/press/expo.png";
import sagaImage from "../assets/press/sagaImage.png";
import yotevoImage from "../assets/press/yotevoImage.png";
import yotewoWinnerImage from "../assets/press/yotewo-winner.png";
import unltdImage from "../assets/press/unltdImage.png";
import nhsImage from "../assets/press/nhsImage.jpeg";
import wbsImage from "../assets/press/wbsImage.png";

export const IN_THE_NEWS_FILTER_TAGS = [
  "All",
  "Press releases",
  "2026",
  "2025",
  "2024",
];

export const IN_THE_NEWS_ITEMS = [
  {
    slug: "unzippd-winner-yotewo-competition-2026",
    image: yotewoWinnerImage,
    title: "Unzippd as the winner of the Yotewo competition!",
    summary:
      "With over 75% of the votes, Unzippd has won 180 hours of free senior developer support, recognizing their innovative British Sign Language research platform and commitment to accessibility and inclusive communication.",
    date: "26 March 2026",
    filters: ["2026"],
    alsoCoveredBy: [
      {
        label: "Brixton Buzz",
        href: "https://www.brixtonbuzz.com/2026/06/brixton-founder-wins-tech-competition-with-platform-built-for-the-deaf-community/",
      },
      {
        label: "UK News Group",
        href: "https://www.uknewsgroup.co.uk/unzippd-wins-inaugural-yotewo-giveaway-competition-2026/",
      },
      {
        label: "LinkedIn (Yotewo)",
        href: "https://www.linkedin.com/posts/today-we-are-excited-to-announce-the-winner-share-7464674867125211136-_f9s/?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAoppFEBLRu7G5JD9kpRxm0DKW16efWft60",
      },
      {
        label: "LinkedIn (Unzippd)",
        href: "https://www.linkedin.com/posts/unzippd-deafresearch-bsl-share-7465401885441642497-E1p-/?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAoppFEBLRu7G5JD9kpRxm0DKW16efWft60",
      },
    ],
    fullReleaseUrl:
      "https://www.brixtonbuzz.com/2026/06/brixton-founder-wins-tech-competition-with-platform-built-for-the-deaf-community/",
  },
  {
    slug: "unzippd-deafexpo-2026-350-deaf-voices",
    image: expoImage,
    title: "350 Deaf Voices. Over 2,500 Responses. One Day.",
    summary:
      "Unzippd shatters records at inaugural DeafExpo 2026, collecting community feedback at a scale never seen before in British Sign Language. BIRMINGHAM – When DeafExpo opened its doors at Birmingham NEC in 2026, it made history as the first event of its kind in the UK.",
    date: "24th May 2026",
    filters: ["Press releases", "2026"],
    alsoCoveredBy: [
      {
        label: "Brixton Buzz",
        href: "https://www.brixtonbuzz.com/2026/06/brixton-founder-wins-tech-competition-with-platform-built-for-the-deaf-community/",
      },
      {
        label: "UK News Group",
        href: "https://www.uknewsgroup.co.uk/350-deaf-voices-2500-responses-one-day/",
      },
    ],
    fullReleaseUrl:
      "https://www.brixtonbuzz.com/2026/06/brixton-founder-wins-tech-competition-with-platform-built-for-the-deaf-community/",
  },
  {
    slug: "unzippd-finalist-inaugural-yotewo-competition-2026",
    image: yotevoImage,
    title: "Unzippd Named Finalist in Inaugural Yotewo Competition 2026",
    summary:
      "BSL-first platform gains global recognition for bridging the communication gap between Deaf communities and brands.",
    filters: ["2026"],
    alsoCoveredBy: [
      {
        label: "LinkedIn",
        href: "https://www.linkedin.com/posts/yotewo2026-aitrends2026-finalist-share-7442117640472461312-MU5w/",
      },
      {
        label: "LinkedIn (Ritchie Beckett)",
        href: "https://www.linkedin.com/posts/ritchie-beckett_the-results-are-in-the-wait-is-over-share-7434188627305357312-SWC5/?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAoppFEBLRu7G5JD9kpRxm0DKW16efWft60",
      },
    ],
    fullReleaseUrl:
      "https://www.linkedin.com/posts/yotewo2026-aitrends2026-finalist-share-7442117640472461312-MU5w/",
    date: "17 March 2026",
  },
  {
    slug: "unzippd-pilot-exposes-invisible-nhs-barriers",
    image: nhsImage,
    title:
      'Unzippd Pilot Exposes "Invisible" NHS Barriers as Deaf BSL Users Become Most Engaged Demographic',
    summary:
      'New Data Reveals 0% Capture Rate of Standard NHS Tools and Proves "Hard-to-Reach" Label is a Systemic Fallacy',
    date: "11 March 2026",
    filters: ["Press releases", "2026"],
    alsoCoveredBy: [
      {
        label: "UK News Group",
        href: "https://www.uknewsgroup.co.uk/unzippd-pilot-exposes-invisible-nhs-barriers-as-deaf-bsl-users-become-most-engaged-demographic/",
      },
      {
        label: "Healthwatch Wandsworth",
        href: "https://www.healthwatchwandsworth.co.uk/news/2026-03-26/unzippd-gp-practice-pilot-capturing-deaf-british-sign-language-bsl-patient-feedback",
      },
      {
        label: "GOV.UK (Locked Out report)",
        href: "https://www.gov.uk/government/publications/bsl-user-experience-of-health-and-social-care-in-uk/locked-out-exclusion-of-deaf-and-deafblind-bsl-users-from-health-and-social-care-in-the-uk-full-report-bsl-and-english-versions",
      },
    ],
    fullReleaseUrl:
      "https://www.healthwatchwandsworth.co.uk/news/2026-03-26/unzippd-gp-practice-pilot-capturing-deaf-british-sign-language-bsl-patient-feedback",
  },
  {
    slug: "unzippd-launches-bsl-feedback-tool-wandsworth-nhs-gp-practices",
    image: pressImageFeatured,
    title:
      "Unzippd Launches Groundbreaking BSL Feedback Tool Across Wandsworth NHS GP Practices",
    summary:
      "Award-Winning Unzippd Launches Inclusive Feedback Solution for the Deaf Community Across NHS GP Practices in Wandsworth",
    date: "19 November 2025",
    filters: ["Press releases", "2025"],
    alsoCoveredBy: [
      {
        label: "UK News Group",
        href: "https://www.uknewsgroup.co.uk/unzippd-launches-groundbreaking-bsl-feedback-tool-across-wandsworth-nhs-gp-practices/",
      },
    ],
    fullReleaseUrl:
      "https://www.uknewsgroup.co.uk/unzippd-launches-groundbreaking-bsl-feedback-tool-across-wandsworth-nhs-gp-practices/",
  },
  {
    slug: "unzippd-wins-sage-small-business-xi-grant",
    image: sagaImage,
    title:
      "Unzippd Wins Sage Small Business XI Grant to Amplify Deaf Voices Through Groundbreaking Tech",
    summary:
      "Unzippd, a UK-based tech company revolutionising how Deaf, BSL users engage with organisations, has been named one of the winners of the prestigious Sage Small Business XI 2025 competition",
    date: "15 August 2025",
    filters: ["2025"],
    alsoCoveredBy: [
      {
        label: "Cricket World",
        href: "https://www.cricketworld.com/sage-small-business-xi-2025-winners-announced-the-hundred-efl-grants/105263.htm",
      },
    ],
    fullReleaseUrl:
      "https://www.cricketworld.com/sage-small-business-xi-2025-winners-announced-the-hundred-efl-grants/105263.htm",
  },
  {
    slug: "unzippd-secures-unltd-award-bsl-communication-prototype",
    image: unltdImage,
    title:
      "Unzippd Secures £8,000 UnLtd Award to Build Pioneering BSL Communication Prototype",
    summary:
      "New Tech Venture Aims to Enable the Deaf Community to Give Feedback on Products and Services in Their Native Language.",
    date: "14 June 2024",
    filters: ["2024"],
    alsoCoveredBy: [
      {
        label: "GOV.UK",
        href: "https://www.gov.uk/government/publications/bsl-user-experience-of-health-and-social-care-in-uk/locked-out-exclusion-of-deaf-and-deafblind-bsl-users-from-health-and-social-care-in-the-uk-full-report-bsl-and-english-versions",
      },
    ],
    fullReleaseUrl:
      "https://www.gov.uk/government/publications/bsl-user-experience-of-health-and-social-care-in-uk/locked-out-exclusion-of-deaf-and-deafblind-bsl-users-from-health-and-social-care-in-the-uk-full-report-bsl-and-english-versions",
  },
  {
    slug: "new-startup-unzippd-launches-for-uk-deaf-bsl-community",
    image: wbsImage,
    title:
      "New Startup Unzippd Launches to Amplify the Voice of the UK's Deaf BSL Community",
    summary:
      "Startup launches to tackle the communication exclusion facing 151,000 BSL users across the UK",
    date: "15 January 2024",
    filters: ["2024"],
    alsoCoveredBy: [
      {
        label: "WBS",
        href: "https://www.wbs.ac.uk/about/meet-our-change-makers/rob-troy/",
      },
    ],
    fullReleaseUrl:
      "https://www.wbs.ac.uk/about/meet-our-change-makers/rob-troy/",
  },
];
